module.exports = __webpack_public_path__ + "static/media/funding.2e89c9a5.svg";